import AbstractComponent from './components/AbstractComponent';

/**
 * Manages a page.
 */
export default class Page {
  /**
   * Tests if the page is loaded on a touch enabled device, or not.
   */
  public static readonly IS_TOUCH_DEVICE = window.matchMedia('( pointer: coarse )').matches;

  /**
   * The last stable window size.
   */
  private lastWindowSize: { width: number, height: number };

  /**
   * The components that are active on the page.
   */
  private components: AbstractComponent[] = [];

  /**
   * Initializes the page.
   */
  constructor() {
    window.addEventListener('resize', () => this.onWindowResize());

    this.lastWindowSize = {
      height: window.innerHeight,
      width: window.innerWidth,
    };
  }

  /**
   * Adds a component to the page.
   *
   * @param component The component to add
   */
  public addComponent(component: AbstractComponent): void {
    component.initialize();

    this.components.push(component);
  }

  /**
   * Called when the window is resized.
   *
   * Calls the `onWindowResize` method on the registrered components.
   */
  private onWindowResize(): void {
    this.components.forEach((component) => {
      component.onWindowResize(this.lastWindowSize);
    });

    this.lastWindowSize = {
      height: window.innerHeight,
      width: window.innerWidth,
    };
  }
}
